export const environment = {
  name: 'production',
  production: true,
  imageApi: 'https://cwa.valmont.com/ImageApi/api/v2',
  managementApi: 'https://camera-api.valmontcoatings.net/api/v1',
  imageTimeout: 15000,
  clientId: '5784643d-993e-4c4d-a48d-1f595902d372',
  authority: 'https://login.microsoftonline.com/8346fbf0-fbc5-44ab-b351-632105f6266f',
  redirectUrl: 'https://cameras.valmontcoatings.net',
  scopeUri: ['api://5784643d-993e-4c4d-a48d-1f595902d372/camera-api-access'],
  localStorage: {
    userEmail: 'camera-ui-user-email',
    userFirstName: 'camera-ui-user-first-name',
    userLastName: 'camera-ui-user-last-name',
    userName: 'camera-ui-user-name',
    userUpn: 'camera-ui-user-upn',
  },
};
